import AssociatedClientList from 'components/lists/associated_clients/AssociatedClientList'
import PageLayout from '../components/layout/PageLayout'

export default function AssociatedClientsPage() {
  return (
    <PageLayout pageTitle='Clientes Asociados' pageDesc='Altas, bajas y modificaciones.'>
      <AssociatedClientList />
    </PageLayout>
  )
}